export const giftCardSimpleForm = {
  form: {
    position: "relative"
  },
  inputsContainer: {
    backgroundColor: "#FFFFFF",
    marginBottom: "20px",
    paddingBottom: "20px",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    overflow: "hidden"
  },
  inputsContainerNoMargin: {
    // borderBottom: "2px solid #76C5C1",
    marginBottom: "0",
    paddingBottom: "0",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px"
  },
  radioButtonsContainer: {
    // padding: "1%",
    // width: "48%",
    width: "50%",
    float: "left"
  },
  customerFieldsContainer: {
    width: "100%"
  },
  customerInputs: {
    width: "21%",
    margin: "1%",
    float: "left",
    display: "block",
    borderBottom: "3px solid #E7E7E7",
    lineHeight: "30px",
    padding: "5px",
    minHeight: "30px",
  },
  customerTitle: {
    fontSize: "16px"
  },
  giftCardButton: {
    backgroundColor: "#3EB9D0",
    color: "#fff"
  }
};

export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};


// WEBPACK FOOTER //
// ./src/components/CRM/Form/style.js